import { Component, ElementRef, OnInit, ViewChild, HostListener } from '@angular/core';
//import { NgwWowService } from 'ngx-wow';
import { DataService, EmmiterService } from 'src/app/services/data.service';
import { HttpParams } from '@angular/common/http';
import { CommonService } from 'src/app/services/common.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { MagnifyFieldSearchComponent } from 'src/app/shared/components/magnify-field-search/magnify-field-search.component';
// Multile Select Dropdown
import { DropdownMultiselectComponent } from 'src/app/shared/components/dropdown-multiselect/dropdown-multiselect.component';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import { NavigationExtras, Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmationDialogComponent } from 'src/app/shared/components/confirmation-dialog/confirmation-dialog.component';
import * as XLSX from 'xlsx';
import { EncryptDecryptService } from 'src/app/services/encrypt-decrypt.service';
import {MemoryStorageService} from 'src/app/services/memory-storage.service';

@Component({
  selector: 'app-userlist',
  templateUrl: './userlist.component.html',
  styleUrls: ['./userlist.component.css']
})
export class UserlistComponent implements OnInit {
  frmuser: FormGroup;
  USER_ID: number;
  buttonAction: string;
  selected_User_detail: any = {};
  columnToHide: any = [];
  lstUser = [];
  lstUserDetails = [];


  lstAuthenticationType = [];
  lstQueryStatus = [];
  showCloseIcon: boolean = false;
  recordCount: number;

  advanceSearchFields: any = [];
  advanceSearchGridData: any = [];
  existingUsersData: any = [];

  fileControlType = 'file';
  fileName = 'Choose File';
  userExcelUploadFileName: string = '';
  userExcelData: any = [];
  userColumn_upload: any = [
    {
      FIELD_NAME: 'USER_NAME',
      DISPLAY_NAME: 'Username'
    }, {
      FIELD_NAME: 'DISPLAY_NAME',
      DISPLAY_NAME: 'Display Name'
    },
    {
      FIELD_NAME: 'AUTHENTICATION_TYPE',
      DISPLAY_NAME: 'Authentication Type'
    },
    {
      FIELD_NAME: 'PRIMARY_EMAIL',
      DISPLAY_NAME: 'Email'
    }];

  userDetailColumn_upload: any = [
    {
      FIELD_NAME: 'PROJECT_NAME',
      DISPLAY_NAME: 'Project'
    }, {
      FIELD_NAME: 'SUBGROUP_NAME',
      DISPLAY_NAME: 'Subgroup'
    },
    {
      FIELD_NAME: 'ROLE_NAME',
      DISPLAY_NAME: 'Role'
    }];
  lstDisplayData = [];

  isValidUserExcelData = false;
  @ViewChild('userExcelUploadFileControl') userExcelUploadFileControl: ElementRef;

  modalReference: any;
  @ViewChild('userDataModal') userDataModal: ElementRef;
  displayName: string = '';
  email: string = '';


  constructor(
    //private wowService: NgwWowService,
    private dataService: DataService,
    private commonService: CommonService,
    private modalService: NgbModal,
    private router: Router,
    private dialog: MatDialog,
    private fb: FormBuilder,
    private encryptdecryptservice: EncryptDecryptService,
    private memorystore: MemoryStorageService
  ) {
    //wowService.init();
    this.frmuser = this.fb.group({
      USER_NAME: [''],
      DISPLAY_NAME: [''],
      PRIMARY_EMAIL: ['']
    });

  }
  @HostListener('paste', ['$event']) blockPaste(e: KeyboardEvent) {
    e.preventDefault();
  }

  @HostListener('copy', ['$event']) blockCopy(e: KeyboardEvent) {
    e.preventDefault();
  }

  @HostListener('cut', ['$event']) blockCut(e: KeyboardEvent) {
    e.preventDefault();
  }

  // document.addEventListener("keyup", function(e) {
  //   var keyCode = e.keyCode ? e.keyCode : e.which;
  //   if (keyCode == 44) {
  //     stopPrntScr();
  //   }
  // });
  ngOnInit(): void {
    this.getUserList();

    this.frmuser = new FormGroup({
      USER_NAME: new FormControl(),
      AUTHENTICATION_TYPE: new FormControl(),
      DISPLAY_NAME: new FormControl(),
      PRIMARY_EMAIL: new FormControl(),
      STATUS: new FormControl(),
    });

    this.lstQueryStatus = [];
    this.lstQueryStatus.push({ id: 'ACTIVE', name: 'Active' });
    this.lstQueryStatus.push({ id: 'INACTIVE', name: 'Inactive' });

    this.lstAuthenticationType = [];
    this.lstAuthenticationType.push({ id: 'AZURE', name: 'AZURE' });
    this.lstAuthenticationType.push({ id: 'FORM', name: 'FORM' });
    this.lstAuthenticationType.push({ id: 'LDAP', name: 'LDAP' });
    this.buttonAction = "Add";

    this.frmuser.get("USER_NAME") ?.valueChanges.subscribe(value => {
      this.sanitizeInput('USER_NAME', value);
    });
    this.frmuser.get("DISPLAY_NAME") ?.valueChanges.subscribe(value => {
      this.sanitizeInput('DISPLAY_NAME', value);
    });
    this.frmuser.get("PRIMARY_EMAIL") ?.valueChanges.subscribe(value => {
      this.sanitizeInput('PRIMARY_EMAIL', value);
    });
  }


  sanitizeInput(field: string, value: string) {
    var sanitizedValue = value.replace(/<[^>]*>/g, '');

    if (field === "DISPLAY_NAME") {
      sanitizedValue = sanitizedValue.replace(/[^a-zA-Z0-9\s]/g, '');
    } else if (field === 'PRIMARY_EMAIL' || field === "USER_NAME") {
      sanitizedValue = sanitizedValue.replace(/[^a-zA-Z0-9@._-]/g, '');
    }
    this.frmuser.get(field) ?.setValue(sanitizedValue, { emitEvent: false });
  }
  AddUser() {
    this.USER_ID = Number(this.selected_User_detail.user_id);

    let validationStatus: boolean = true;
    let validationMessage: string = '';
    if (this.frmuser.valid) {
    }
    validationMessage += '- Please fill the required field(s).\r <br/>';

    if (this.frmuser.get("USER_NAME").value == null) {
      validationMessage += '- Please enter username.\r <br/>';
      validationStatus = false;
    }
    else if (this.frmuser.get("USER_NAME").value.toString().trim().length <= 0) {
      validationMessage += '- Please enter username.\r <br/>';
      validationStatus = false;
    }

    // if (this.frmuser.get("AUTHENTICATION_TYPE").value == null) {
    //   validationMessage += '- Select  one Authentication Type.\r <br/>';
    //   validationStatus = false;
    // }
    // else if (this.frmuser.get("AUTHENTICATION_TYPE").value.length <= 0) {
    //   validationMessage += '- Select  one Authentication Type.\r <br/>';
    //   validationStatus = false;
    // }

    if (this.frmuser.get("DISPLAY_NAME").value == null) {
      validationMessage += '- Please enter display name.\r <br/>';
      validationStatus = false;
    }
    else if (this.frmuser.get("DISPLAY_NAME").value.toString().trim().length <= 0) {
      validationMessage += '- Please enter display name.\r <br/>';
      validationStatus = false;
    }
    // else if(this.hasHtmlTags("DISPLAY_NAME")){
    //   validationMessage += '- Display name must not contain HTML tags like < or >.\r <br/>';
    //   validationStatus = false;
    // }
    if (this.frmuser.get("PRIMARY_EMAIL").value == null) {
      validationMessage += '- Please enter primary email.\r <br/>';
      validationStatus = false;
    }
    else if (this.frmuser.get("PRIMARY_EMAIL").value.toString().trim().length <= 0) {
      validationMessage += '- Please enter primary email.\r <br/>';
      validationStatus = false;
    }
    // else if (this.hasHtmlTags("PRIMARY_EMAIL")) {
    //   validationMessage += '- Please enter primary email.\r <br/>';
    //   validationStatus = false;
    // }


    if (this.frmuser.get("STATUS").value == null) {
      validationMessage += '- Select status Type.\r <br/>';
      validationStatus = false;
    }
    else if (this.frmuser.get("STATUS").value.length <= 0) {
      validationMessage += '- Select status Type.\r <br/>';
      validationStatus = false;
    }

    if (!validationStatus) {
      this.commonService.showMessageBox(validationMessage, 'Alert');
      return;
    }
    if (this.buttonAction == "Add") {
      // var userExists = this.existingUsersData.filter(object =>
      //  ((object['Username'].toLowerCase() == (this.frmuser.get("USER_NAME").value).toLowerCase())) && (object['Status'].toLowerCase() == (this.frmuser.get("STATUS").value).toLowerCase()));
      var userExists = this.existingUsersData.filter(object =>
        ((object['Username'].toLowerCase() == (this.frmuser.get("USER_NAME").value).toLowerCase())));

      if (userExists != undefined && userExists.length > 0) {
        this.commonService.showMessageBox("User already exists.Please check User Name", "Message", "error");
        return;
      }
    }
    if (this.USER_ID > 0) {
      let body = {
        // USER_ID: this.USER_ID,
        editeduserid: this.encryptdecryptservice.encryptUsingAES256(this.USER_ID),
        USER_NAME: this.frmuser.get("USER_NAME").value,
        AUTHENTICATION_TYPE: this.frmuser.get("AUTHENTICATION_TYPE").value,
        DISPLAY_NAME: this.frmuser.get("DISPLAY_NAME").value,
        PRIMARY_EMAIL: this.frmuser.get("PRIMARY_EMAIL").value,
        USER_STATUS: this.frmuser.get("STATUS").value,
        // // CHANGED_BY: this.commonService.getUserInfoFromLocalStorage('userId')
        // CHANGED_BY: this.memorystore.getItem('userId')
        CHANGEDBY: this.encryptdecryptservice.encryptUsingAES256(this.memorystore.getItem('userId'))
      };

      this.dataService.postData("user/update_user", body).subscribe(res => {
        if (res != null && (res.error_message == null || res.error_message == "")) {
          if (res.status == true) {
            this.recordCount = res.data.length;
            if (this.recordCount == 0) {
              this.commonService.showMessageBox("No record found.", "Message", "error");
            }
            else {
              this.commonService.showMessageBox("User updated successfully.", "Message", "success");
              this.reset();
              this.getUserList();
            }
          }
          else {
            if (res != null)
              this.commonService.showMessageBox(res.error_message, "Message", "error");
            else
              this.commonService.showMessageBox("Something went wront.", "error");
          }
        }
        else {
          if (res.errorCode != 0 && res.errorCode == 4000) {
            this.router.navigateByUrl('/unauthorized');
            return;
          }
          if (res.errorCode != 0 && res.errorCode == 3000) {
            this.commonService.showMessageBox("Internal error")
          }
        }

      }, error => {
        this.commonService.showMessageBox(error.toString());
        if (error.includes("401")) {
          this.router.navigateByUrl('/unauthorized');
          return;
        }
      })
      //  err => {
      //   this.commonService.showMessageBox(err.toString());
      // });
    }
    else {
      {
        let body = {
          USER_NAME: this.frmuser.get("USER_NAME").value,
          AUTHENTICATION_TYPE: this.frmuser.get("AUTHENTICATION_TYPE").value,
          DISPLAY_NAME: this.frmuser.get("DISPLAY_NAME").value,
          PRIMARY_EMAIL: this.frmuser.get("PRIMARY_EMAIL").value,
          USER_STATUS: this.frmuser.get("STATUS").value,
          // // CREATED_BY: this.commonService.getUserInfoFromLocalStorage('userId'),
          // // PROJECT_ID: this.commonService.getUserInfoFromLocalStorage('projectId')
          // CREATED_BY: this.memorystore.getItem('userId'),
          // PROJECT_ID: this.memorystore.getItem('projectId')
          // CREATED_BY: this.commonService.getUserInfoFromLocalStorage('userId'),
          // PROJECT_ID: this.commonService.getUserInfoFromLocalStorage('projectId')
          CREATEDBY: this.encryptdecryptservice.encryptUsingAES256(this.memorystore.getItem('userId')),
          PROJECTID: this.encryptdecryptservice.encryptUsingAES256(this.memorystore.getItem('projectId'))
        };

        this.dataService.postData("user/add_user", body).subscribe(res => {
          if (res != null && (res.error_message == null || res.error_message == "")) {
            if (res.status == true) {
              this.recordCount = res.data.length;

              if (this.recordCount == 0) {
                this.commonService.showMessageBox("No record found.", "Message", "error");
              }
              else {
                this.commonService.showMessageBox("User created successfully.", "Message", "success");
                this.reset();
                this.getUserList();
              }
            }
            else {
              if (res != null)
                this.commonService.showMessageBox(res.error_message, "Message", "error");
              else
                this.commonService.showMessageBox("Something went wront.", "error");
            }
          }
          else {
            if (res.errorCode != 0 && res.errorCode == 4000) {
              this.router.navigateByUrl('/unauthorized');
              return;
            }
            if (res.errorCode != 0 && res.errorCode == 3000) {
              this.commonService.showMessageBox("Internal error")
            }
          }

        }, error => {
          this.commonService.showMessageBox(error.toString());
          if (error.includes("401")) {
            this.router.navigateByUrl('/unauthorized');
            return;
          }
        });
        // err => {
        //   this.commonService.showMessageBox(err.toString());
        // });
      }
    }

  }

  reset() {
    this.frmuser.get('USER_NAME').setValue('');
    this.frmuser.get('AUTHENTICATION_TYPE').setValue('');
    this.frmuser.get('DISPLAY_NAME').setValue('');
    this.frmuser.get('PRIMARY_EMAIL').setValue('');
    this.frmuser.get('STATUS').setValue('');

    this.selected_User_detail = {};
    this.buttonAction = "Add";
  }

  getUserDetail() {
    let params = {
      // USER_ID: Number(this.commonService.getUserInfoFromLocalStorage('edit_user_id'))
      // USER_ID: Number(this.memorystore.getItem('edit_user_id'))
      editeduserid: this.encryptdecryptservice.encryptUsingAES256(this.memorystore.getItem('edit_user_id')),
      xusrid : this.encryptdecryptservice.encryptUsingAES256(this.memorystore.getItem('userId'))//Added by imran on 01-04-26
    };

    this.dataService.postData('user/get_user', params).subscribe((res) => {
      if (res != null && (res.error_message == null || res.error_message == "")) {
        if (res.data != null) {
          const formControls: any = {};
          let fieldValidators = [];
          fieldValidators = [Validators.required, Validators.pattern("^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$")]
          formControls["PRIMARY_EMAIL"] = new FormControl('', fieldValidators);
          formControls["PRIMARY_EMAIL"].value = res.data.PRIMARY_EMAIL;

          let fieldValidators1 = [];
          fieldValidators1 = [Validators.required]
          formControls["USER_NAME"] = new FormControl('', fieldValidators1);
          formControls["USER_NAME"].value = res.data.USER_NAME;

          let fieldValidators2 = [];
          fieldValidators2 = [Validators.requiredTrue]
          formControls["AUTHENTICATION_TYPE"] = new FormControl('', fieldValidators2);
          formControls["AUTHENTICATION_TYPE"].value = res.data.AUTHENTICATION_TYPE;

          let fieldValidators3 = [];
          fieldValidators3 = [Validators.required]
          formControls["DISPLAY_NAME"] = new FormControl('', fieldValidators3);
          formControls["DISPLAY_NAME"].value = res.data.DISPLAY_NAME;

          let fieldValidators4 = [];
          fieldValidators4 = [Validators.required]
          formControls["STATUS"] = new FormControl('', fieldValidators4);
          formControls["STATUS"].value = res.data.USER_STATUS;

          this.frmuser = new FormGroup(formControls);
        }
      }
      else {
        if (res.errorCode != 0 && res.errorCode == 4000) {
          this.router.navigateByUrl('/unauthorized');
          return;
        }
        if (res.errorCode != 0 && res.errorCode == 3000) {
          this.commonService.showMessageBox("Internal error")
        }
      }
    },
      error => {
        if (error.includes("401")) {
          this.router.navigateByUrl('/unauthorized');
          return;
        }
      });
  }

  getUserList() {
    this.advanceSearchGridData = [];
    this.existingUsersData = [];
    let reqData1 = {
       xusrid : this.encryptdecryptservice.encryptUsingAES256(this.memorystore.getItem('userId'))//Added by imran on 01-04-26
    };

    this.advanceSearchGridData = [];
    this.dataService.postData('user/get_users', reqData1).subscribe((res) => {
      if (res != null && (res.error_message == null || res.error_message == "")) {
        if (
          res != undefined &&
          res.data != null &&
          res.data.length > 0
        ) {

          let user_details = res.data;
          user_details.forEach((item) => {
            let rowData = {
              user_id: item.USER_ID,
              "Username": item.USER_NAME,
              //"Authentication": item.AUTHENTICATION_TYPE,
              "Display Name": item.DISPLAY_NAME,
              "Email": item.PRIMARY_EMAIL,
              "Status": item.Status,
              // "action_icon_Edit": item.Status === 'ACTIVE' ? "fa fa-edit" : "fa fa-toggle-on",
              "action_icon_Edit": "fa fa-edit",
              // "action_icon_Delete": item.Status === 'ACTIVE' ? "fa fa-toggle-on" : "fa fa-toggle-off",
              // "action_icon_Delete": item.Status === 'ACTIVE' ? "fa fa-trash" : "",
              "action_icon_Access": item.Status === 'ACTIVE' ? "fa fa-code-fork" : ""
            };
            this.advanceSearchGridData.push(rowData);
            this.existingUsersData.push(rowData);

          });
          this.columnToHide.push("user_id");
          this.columnToHide.push("user_parent_id");
        }
      }
      else {
        if (res.errorCode != 0 && res.errorCode == 4000) {
          this.router.navigateByUrl('/unauthorized');
          return;
        }
        if (res.errorCode != 0 && res.errorCode == 3000) {
          this.commonService.showMessageBox("Internal error")
        }
      }
      if (this.advanceSearchGridData.length <= 0) {
        this.commonService.showMessageBox('No data found', 'Information');
      }
    },
      error => {
        if (error.includes("401")) {
          this.router.navigateByUrl('/unauthorized');
          return;
        }
      });
  }

  User_Details_grid_CellClick(event: any) {

    var rowEditData = this.advanceSearchGridData.filter(
      (item) => item.user_id == event.rowData.user_id
    );
    if (rowEditData != undefined) {
      this.selected_User_detail = rowEditData[0];
      if (event.columnName == "action_icon_Delete") {
        //this.deleteUser_Detail_GridRowConfirmationdialog();
        if (event.rowData.Status === 'INACTIVE') {
          this.activedInactiveUser_GridRowConfirmationdialog(rowEditData[0].user_id);
          this.updateInactiveUser(rowEditData[0].user_id);
        }
      }
      if (event.columnName == "action_icon_Edit") {
        // this.commonService.setUserInfoToLocalStorage("edit_user_id", rowEditData[0].user_id);
        this.memorystore.setItem("edit_user_id", rowEditData[0].user_id);
        // if (event.rowData.Status === 'INACTIVE') {
        //   this.activedInactiveUser_GridRowConfirmationdialog(rowEditData[0].user_id);
        //   // this.updateInactiveUser(rowEditData[0].user_id);
        // }
        // else {
        //  this.getUserDetail();
        //}
        this.getUserDetail();
        this.buttonAction = "Update";
      }

      if (event.columnName == "action_icon_Access") {
        // this.commonService.setUserInfoToLocalStorage("edit_user_id", rowEditData[0].user_id)
        this.memorystore.setItem("edit_user_id", rowEditData[0].user_id)
        this.router.navigate(['/userdetail']);
      }
    }

  }

  deleteUser_Detail_GridRowConfirmationdialog() {
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      disableClose: true,
      data: {
        title: "Alert",
        message: "Are you sure want to delete ?",
        messageBoxType: "question",
      },
    });
    dialogRef.afterClosed().subscribe((confirmed: boolean) => {
      if (confirmed) {
        this.delete_user_detail();
        this.getUserList();
      }
      else {
        this.selected_User_detail = {};
      }
    });
  }

  activedInactiveUser_GridRowConfirmationdialog(inactive_user_id) {
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      disableClose: true,
      data: {
        title: "Alert",
        message: "Are you sure want to activate ?",
        messageBoxType: "question",
      },
    });
    dialogRef.afterClosed().subscribe((confirmed: boolean) => {
      if (confirmed) {
        this.updateInactiveUser(inactive_user_id);
        this.getUserList();
      }
      else {
        this.selected_User_detail = {};
      }
    });
  }

  delete_user_detail() {
    let param = {
      USER_ID: this.selected_User_detail.user_id,
      // CHANGED_BY: Number(this.commonService.getUserInfoFromLocalStorage("userId"))
      CHANGED_BY: Number(this.memorystore.getItem("userId"))
    }

    this.dataService.postData("user/delete_user", param).subscribe(res => {
      if (res != null && (res.error_message == null || res.error_message == "")) {
        if (res.status == true) {
          this.selected_User_detail = {};
          this.commonService.showMessageBox("Deleted successfully.", "Message");
        }
        else {
          this.commonService.showMessageBox("Record could not be deleted.", "Message");
        }
      }
      else {
        if (res.errorCode != 0 && res.errorCode == 4000) {
          this.router.navigateByUrl('/unauthorized');
          return;
        }
        if (res.errorCode != 0 && res.errorCode == 3000) {
          this.commonService.showMessageBox("Internal error")
        }
      }
    },
    error => {
      if (error.includes("401")) {
        this.router.navigateByUrl('/unauthorized');
        return;
      }
    });
  }

  downloadExcelTemplate() {
    let lstFile = [];
    let obj = {};

    if (this.userColumn_upload != null) {
      this.userColumn_upload.forEach(column => {
        obj[column["DISPLAY_NAME"]] = '';
      });
    }
    if (this.userDetailColumn_upload != null) {
      this.userDetailColumn_upload.forEach(column => {
        obj[column["DISPLAY_NAME"]] = '';
      });
    }
    lstFile.push(obj);

    const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(lstFile);
    const wb: XLSX.WorkBook = XLSX.utils.book_new();

    XLSX.utils.book_append_sheet(wb, ws, 'LoadDataSheet');

    //const ws_master: XLSX.WorkSheet = XLSX.utils.json_to_sheet(master_data); //master data
    //ws_master['!protect'] = { selectLockedCells: false, autoFilter: false, formatColumns: false }; //master data
    //XLSX.utils.book_append_sheet(wb, ws_master, 'MasterData'); //master data

    XLSX.writeFile(wb, 'usertemplate_' + new Date().getTime() + '.xlsx');

  }

  onUserExcelFileUpload(excelFile: any) {
    this.isValidUserExcelData = false;
    this.userExcelData = [];
    this.userExcelUploadFileName = 'Choose File';
    if (excelFile.target.files && excelFile.target.files[0]) {

      if (excelFile.target.files[0].type.toLowerCase() != "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet") {
        this.commonService.showMessageBox("Please select excel file.", "Alert");
        this.userExcelUploadFileControl.nativeElement.value = '';
        return;
      }
      let workBook = null;
      const reader = new FileReader();
      const excelfile = excelFile.target.files[0];
      this.userExcelUploadFileName = excelFile.target.files[0].name;
      reader.onload = async (event) => {
        const data = reader.result;
        workBook = XLSX.read(data, { type: 'binary' });
        // const sheet = workBook.Sheets[Object.keys(workBook.Sheets)[0]];
        const sheet = workBook.Sheets['LoadDataSheet'];
        if (sheet != undefined)
          this.userExcelData = XLSX.utils.sheet_to_json(sheet, { defval: "" });
        if (this.userExcelData == undefined || this.userExcelData.length == 0) {
          this.commonService.showMessageBox("Upload Valid file.", "Alert");
          this.userExcelUploadFileControl.nativeElement.value = '';
          this.userExcelUploadFileName = 'Choose File';
          return;
        }

        let missingCol = "";
        let cols = Object.keys(this.userExcelData[0]);
        this.userColumn_upload.forEach(f => {
          if (cols.findIndex(a => a == f["DISPLAY_NAME"]) == -1) {
            missingCol = (missingCol == '') ? f : missingCol + ', ' + f;
          }
        });

        if (missingCol != "") {
          this.commonService.showMessageBox("Below column(s) are missing in excel data file.<br>" + missingCol, "Alert");
          this.userExcelUploadFileControl.nativeElement.value = '';
          this.userExcelUploadFileName = 'Choose File';
          return;
        }

        this.lstDisplayData = [];

        let intCount = 1;

        this.userExcelData.forEach(item => {
          let count = 0;
          this.userColumn_upload.forEach(f => {
            if (item[f["DISPLAY_NAME"]] == "") {
              count++;
            }
          });

          item["srNo"] = intCount;

          let obj = {};
          //no line items
          if (this.userDetailColumn_upload.length == 0) {
            this.userColumn_upload.forEach(f => {
              obj[f["FIELD_NAME"]] = item[f["DISPLAY_NAME"]];
              this.lstDisplayData.push(obj);
              intCount = intCount + 1;
            });
          }
          else {
            if (count < this.userColumn_upload.length) {
              this.userColumn_upload.forEach(f => {
                obj[f["FIELD_NAME"]] = item[f["DISPLAY_NAME"]];
              });
              var obj1 = {};
              var countChildValue = 0;
              this.userDetailColumn_upload.forEach(f => {
                if (item[f["DISPLAY_NAME"]] != null && item[f["DISPLAY_NAME"]] != "") {
                  obj1[f["FIELD_NAME"]] = item[f["DISPLAY_NAME"]];
                }
                else {
                  countChildValue++;
                }
              });
              if (countChildValue < this.userDetailColumn_upload.length) {
                obj["lstUserDetail"] = [];
                obj["lstUserDetail"].push(obj1);
                obj1['Message'] = "";
              }
              this.lstDisplayData.push(obj);
              intCount = intCount + 1;
            }
            else {
              item["srNo"] = intCount - 1;
              var obj1 = {};
              var countChildValue = 0;
              this.userDetailColumn_upload.forEach(f => {
                if (item[f["DISPLAY_NAME"]] != null && item[f["DISPLAY_NAME"]] != "") {
                  obj1[f["FIELD_NAME"]] = item[f["DISPLAY_NAME"]];
                }
                else {
                  countChildValue++;
                }
              });
              if (countChildValue < this.userDetailColumn_upload.length) {
                obj1['Message'] = "";
                this.lstDisplayData[this.lstDisplayData.length - 1]["lstUserDetail"].push(obj1);
              }
            }
          }
        });
        let result = await this.fileValidation(this.userExcelUploadFileName);
        if (result == false) {
          this.userExcelUploadFileControl.nativeElement.value = '';
          this.userExcelUploadFileName = 'Choose File';
          return;
        }
        else {
          this.isValidUserExcelData = true;
        }

      }
      reader.readAsBinaryString(excelfile);
      if (this.userExcelUploadFileControl) {
        this.userExcelUploadFileControl.nativeElement.value = '';
      }
    } else {
      this.userExcelUploadFileName = 'Choose File';
    }

  }

  async fileValidation(filename): Promise<Boolean> {
    return true;
  }

  showModal(modelTemplate, modalSize: string = 'lg') {
    this.modalReference = this.modalService.open(modelTemplate, {
      size: modalSize, centered: true, backdrop: 'static',
      keyboard: false
    });
  }

  viewUserData() {
    this.showModal(this.userDataModal, 'lg');
  }

  uploadUserData() {


    let isValid: boolean = true;
    let strErrorMessage = "";
    let strUserNameMessage = "";
    let strDisplayNameMessage = "";
    let strPrimaryEmailMessage = "";
    let strProjectNameMessage = "";
    let strAuthenticationTypeMessage = "";

    this.lstDisplayData.forEach(user => {

      if (user.USER_NAME.toString().trim() == '') {
        isValid = false;
        strUserNameMessage = "User Name should not be blank";
      }
      if (user.DISPLAY_NAME.toString().trim() == '') {
        isValid = false;
        strDisplayNameMessage = "Display Name should not be blank";
      }
      if (user.PRIMARY_EMAIL.toString().trim() == '') {
        isValid = false;
        strPrimaryEmailMessage = "Primary Email should not be blank";
      }
      // if (user.AUTHENTICATION_TYPE.toString().trim() == '') {
      //   isValid = false;
      //   strAuthenticationTypeMessage = "Authentication Type should not be blank";
      // }

      user.lstUserDetail.forEach(d => {
        if (d.hasOwnProperty('PROJECT_NAME')) {
          if (d.PROJECT_NAME.toString().trim() == '') {
            strProjectNameMessage = "Project Name should not be blank";
            isValid = false;
          }
        }
        else {
          strProjectNameMessage = "Project Name should not be blank";
          isValid = false;
        }
      });
    });

    if (isValid != true) {
      strErrorMessage = strUserNameMessage

      if (strDisplayNameMessage != "") {
        if (strErrorMessage != "")
          strErrorMessage = strErrorMessage + "<BR>"
        strErrorMessage = strErrorMessage + strDisplayNameMessage
      }

      if (strPrimaryEmailMessage != "") {
        if (strErrorMessage != "")
          strErrorMessage = strErrorMessage + "<BR>"
        strErrorMessage = strErrorMessage + strPrimaryEmailMessage
      }

      if (strAuthenticationTypeMessage != "") {
        if (strErrorMessage != "")
          strErrorMessage = strErrorMessage + "<BR>"
        strErrorMessage = strErrorMessage + strAuthenticationTypeMessage
      }

      if (strProjectNameMessage != "") {
        if (strErrorMessage != "")
          strErrorMessage = strErrorMessage + "<BR>"
        strErrorMessage = strErrorMessage + strProjectNameMessage

      }
      this.commonService.showMessageBox(strErrorMessage, 'Validation', 'error');
      return;
    }

    let userRequest = {
      userExcelData: this.lstDisplayData
    };
    if (this.lstDisplayData.length == 0) {
      this.commonService.showMessageBox("No data found in file.", "Alert");
      this.userExcelUploadFileControl.nativeElement.value = '';
      this.userExcelUploadFileName = 'Choose File';
      this.userExcelData = [];
      this.isValidUserExcelData = false;
      return;
    }
    this.dataService.postData('user/PostExceluserdata', userRequest).subscribe((res) => {
     // if (res != null && (res.error_message == null || res.error_message == "")) { commented added by imran on 29-01-2029
      if (res != null) {
        if (res != undefined) {
          this.getUserList();
          if (res.status == true) {
            this.commonService.showMessageBox("User(s) created successfully.", 'Message');
          }
          else {           
            this.commonService.showMessageBox(res.error_message, 'Alert');
          }
          this.userExcelUploadFileControl.nativeElement.value = '';
          this.userExcelUploadFileName = 'Choose File';
          this.userExcelData = [];
          this.isValidUserExcelData = false;
        }
      }
      else {
        if (res.errorCode != 0 && res.errorCode == 4000) {
          this.router.navigateByUrl('/unauthorized');
          return;
        }
        if (res.errorCode != 0 && res.errorCode == 3000) {
          this.commonService.showMessageBox("Internal error")
        }
      }

    },
    error => {
      if (error.includes("401")) {
        this.router.navigateByUrl('/unauthorized');
        return;
      }
    });

  }

  searchQuery() {
  }
  updateInactiveUser(user_Id: any) {
    let userDetailModel = {
      USER_ID: user_Id,
      // PROJECT_ID: this.commonService.getUserInfoFromLocalStorage('projectId')
      PROJECT_ID: this.memorystore.getItem('projectId')
    };
    this.dataService.postData("user/update_inactiveuser", userDetailModel).subscribe(res => {
      if (res != null && (res.error_message == null || res.error_message == "")) {
        if (res != null && res.status == true) {
          this.commonService.showMessageBox("User made active successfully.", "Message", "success");
          this.getUserList();
        }
        else {
          if (res != null)
            this.commonService.showMessageBox(res.error_message, "Message", "error");
          else
            this.commonService.showMessageBox("Something went wrong.", "error");
        }
      }
      else {
        if (res.errorCode != 0 && res.errorCode == 4000) {
          this.router.navigateByUrl('/unauthorized');
          return;
        }
        if (res.errorCode != 0 && res.errorCode == 3000) {
          this.commonService.showMessageBox("Internal error")
        }
      }

    },error => {
      this.commonService.showMessageBox(error.toString());
      if (error.includes("401")) {
        this.router.navigateByUrl('/unauthorized');
        return;
      }
    });
    // err => {
    //   this.commonService.showMessageBox(err.toString());
    // });
  }
}


